/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomerDto } from './CustomerDto';
import {
    CustomerDtoFromJSON,
    CustomerDtoFromJSONTyped,
    CustomerDtoToJSON,
    CustomerDtoToJSONTyped,
} from './CustomerDto';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface CustomerResponse
 */
export interface CustomerResponse {
    /**
     * 
     * @type {string}
     * @memberof CustomerResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof CustomerResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof CustomerResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof CustomerResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {CustomerDto}
     * @memberof CustomerResponse
     */
    data?: CustomerDto;
}

/**
 * Check if a given object implements the CustomerResponse interface.
 */
export function instanceOfCustomerResponse(value: object): value is CustomerResponse {
    return true;
}

export function CustomerResponseFromJSON(json: any): CustomerResponse {
    return CustomerResponseFromJSONTyped(json, false);
}

export function CustomerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : CustomerDtoFromJSON(json['data']),
    };
}

export function CustomerResponseToJSON(json: any): CustomerResponse {
    return CustomerResponseToJSONTyped(json, false);
}

export function CustomerResponseToJSONTyped(value?: CustomerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': CustomerDtoToJSON(value['data']),
    };
}

